<ng-container *ngIf="!!element">
  <div class="field-container title">
    <mat-form-field class="title">
      <input [(ngModel)]="element.title" matInput placeholder="{{'general.title' | translate}}">
    </mat-form-field>
    <div class="error" *ngIf="titleError">{{'dynamicContent.openHours.errors.title' | translate}}</div>
  </div>

  <code-area [isString]="true" type="html" [value]="element.snippet" [parent]="element" key="snippet"></code-area>

  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
  </div>
</ng-container>
